module.exports = __webpack_public_path__ + "img/logo.381d6a3e.png";